import usePrivateAxios from '@/common/api/usePrivateAxios'
import { PublicCompanyLeadsFunnelUpdateValidationSchema } from '@/features/publicCompanyLeadsFunnel/schemas/update.schema'
import { useMutation } from '@tanstack/react-query'

interface UseUpdatePublicCompanyLeadManagersProps {
  id?: string
  onSuccess: () => void
  onError: (error: any) => void
}

export const useUpdatePublicCompanyLeadManagers = ({
  id,
  onSuccess,
  onError,
}: UseUpdatePublicCompanyLeadManagersProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updatePublicCompanyLeadManagers'],
    mutationFn: (data: PublicCompanyLeadsFunnelUpdateValidationSchema) => {
      const lead = {
        commercial_manager_id: data.commercial_manager?.value,
        commercial_manager_substitute_id: data.commercial_manager_substitute?.value || 'null',
      }

      return privateAxios.putForm(`/funnel/public/leads/${id}/update_managers`, {
        lead,
      })
    },
    onSuccess,
    onError,
  })
}
